/**
 * Extracts utility color value from class name
 * @example getUtilityColor('text-utility-gray-500') => 'utility-gray-500'
 * @param className - Input class (e.g., 'text-utility-gray-500')
 * @param type - Utility type ('text' | 'border' | 'bg')
 * @returns Utility color value or className
 */
export const getUtilityColor = (
  type: 'text' | 'border' | 'bg',
  className?: string,
): string | undefined => {
  if (!className || typeof className !== 'string') return undefined;

  const regex = new RegExp(`${type}-utility-([a-zA-Z-]+)-([0-9]+)`);
  const match = className.match(regex);
  if (match) {
    return match[0].replace(`${type}-`, '');
  }
  if (type === 'text') {
    // For tabs(type is text for tabs), we return the className as-is since they only receive color classes
    // and we want to preserve non-utility color values (e.g. "text-success-primary")
    return className;
  }
  // Return undefined for non-color classes in Divider to avoid conflicts with Divider-lineColor.
  // Any class other than color needs to be undefined to ensure proper styling
  return undefined;
};
